import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToDecimal',
  standalone:true
})

export class NumberToDecimalPipe implements PipeTransform {

  transform(number: any): string {

    if(number===null||number===undefined) return number
    else {
    const formattedValue = parseFloat(number).toFixed(2)
    return `${formattedValue}`;
    }
  }
};
